function tags($http, $q) {
  let tagsSettings
  function fetchTags(_search) {
    const req = {
      method: 'GET',
      url: `/tags-api/v2/search?prefix=${_search}&size=25`,
      timeout: 100000,
    }

    return $http(req)
  }

  function putTags(_tag) {
    const tag = _tag
    const req = {
      method: 'POST',
      url: '/tags-api/add',
      data: tag,
      timeout: 100000,
    }
    return $http(req)
  }

  function searchSuccess(resolve, results) {
    // need to process the results into the format the tags input needs?

    // console.log("SUCCESS", results);
    resolve(results)
  }

  function searchError(reject, results) {
    // console.log("ERROR", results);
    reject(results)
  }

  this.search = (searchText) => {
    const deferred = $q.defer()

    fetchTags(searchText).then(
      searchSuccess.bind(this, deferred.resolve),
      searchError.bind(this, deferred.reject)
    )
    return deferred.promise
  }

  // Needs to be called when the user selects a tag
  this.added = (tagId) => {
    // need to tell tag api we are using this
    putTags(tagId)
  }

  this.getTagsSettings = () => {
    return tagsSettings
  }

  this.setTagsSettings = (settings) => {
    tagsSettings = settings
  }

  // Needs to called when user
  // this.removed = (tagId) => {
  // need to tell tag api we are not using this
  //    console.log("Decrement", tagId)
  // }
}

export default ['$http', '$q', 'toastr', tags]
